

import jsencrypt_1 from 'jsencrypt'
// import { chunk } from 'lodash';
import { SecureRandom } from "./rng";

var b64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
var b64pad = '=';
function hex2b64(h) {
    var i;
    var c;
    var ret = '';
    for (i = 0; i + 3 <= h.length; i += 3) {
        c = parseInt(h.substring(i, i + 3), 16);
        ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
    }
    if (i + 1 === h.length) {
        c = parseInt(h.substring(i, i + 1), 16);
        ret += b64map.charAt(c << 2);
    }
    else if (i + 2 === h.length) {
        c = parseInt(h.substring(i, i + 2), 16);
        ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
    }
    while ((ret.length & 3) > 0) {
        ret += b64pad;
    }
    return ret;
}

var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
function int2char(n) {
    return BI_RM.charAt(n);
}
function b64tohex(s) {
    var ret = '';
    var i;
    var k = 0; // b64 state, 0-3
    var slop = 0;
    for (i = 0; i < s.length; ++i) {
        if (s.charAt(i) === b64pad) {
            break;
        }
        var v = b64map.indexOf(s.charAt(i));
        if (v < 0) {
            continue;
        }
        if (k === 0) {
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 1;
        }
        else if (k === 1) {
            ret += int2char((slop << 2) | (v >> 4));
            slop = v & 0xf;
            k = 2;
        }
        else if (k === 2) {
            ret += int2char(slop);
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 3;
        }
        else {
            ret += int2char((slop << 2) | (v >> 4));
            ret += int2char(v & 0xf);
            k = 0;
        }
    }
    if (k === 1) {
        ret += int2char(slop << 2);
    }
    return ret;
}
function parseBigInt(key, b, a) {
    // 不知道BigInteger的具体定义，只能通过现有字段间接创建实例
    // 解密过程中取maxLength本来就需要key.n, 故而此处是安全的
    const BigInteger2 = key.n.constructor
    return new BigInteger2(b, a)
}

function encryptByteArray(key, text) {
    var maxLength = (key.n.bitLength() + 7) >> 3;
    var m = pkcs1pad2FromByteArray(text, maxLength, key);
    if (m == null) {
        return null;
    }
    var c = key.doPublic(m);
    var h = c.toString(16);
    var length = h.length;
    // fix zero before result
    for (var i = 0; i < maxLength * 2 - length; i++) {
        h = "0" + h;
    }
    return h;
}

function pkcs1pad2FromByteArray(s, n, key) {
    if (n < s.length + 11) { // TODO: fix for utf-8
        console.error("Message too long for RSA");
        return null;
    }
    var ba = [];
    var i = s.length - 1;
    while (i >= 0 && n > 0) {
        ba[--n] = s[i--]
    }
    ba[--n] = 0;
    var rng = new SecureRandom();
    var x = [];
    while (n > 2) { // random non-zero pad
        x[0] = 0;
        while (x[0] == 0) {
            rng.nextBytes(x);
        }
        ba[--n] = x[0];
    }
    ba[--n] = 2;
    ba[--n] = 0;
    return parseBigInt(key, ba)
}

/**
 * rsa公钥加密长字符串
 * @param str
 * @param publicKey
 * @returns {any}
 */
export function encryptPublicLong(text, publicKey) {
    var rsa = new jsencrypt_1();
    rsa.setPublicKey(publicKey);
    var key = rsa.getKey();
    var maxLength = ((key.n.bitLength() + 7) >> 3) - 11;
    let encoder = new TextEncoder("utf-8");
    let binText = encoder.encode(text);
    try {
        var ct_1 = [];
        if (binText.length > maxLength) {
            var lt = chunk(binText, 117)
            lt.forEach(function (entry) {
                var t1 = encryptByteArray(key, entry)
                ct_1 += t1;
            });

            return hex2b64(ct_1)
        }
        var t = key.encrypt(text);
        var y = hex2b64(t);
        return y;
    }
    catch (ex) {
        return false;
    }
}

function pkcs1unpadByteArray(d, n) {
    var b = d.toByteArray();
    var i = 0;
    while (i < b.length && b[i] == 0) {
        ++i;
    }
    if (b.length - i != n - 1 || b[i] != 2) {
        return null;
    }
    ++i;
    while (b[i] != 0) {
        if (++i >= b.length) {
            return null;
        }
    }
    ++i;
    return b.slice(i);
}

function decryptByteArray(key, text) {
    var c = parseBigInt(key, text, 16);
    var m = key.doPrivate(c);
    if (m == null) {
        return null;
    }
    return pkcs1unpadByteArray(m, (key.n.bitLength() + 7) >> 3);
}

/**
 * rsa私钥解密长字符串
 * @param str
 * @param privateKey
 * @returns {any}
 */
export function decryptPrivateLong(text, privateKey) {
    var rsa = new jsencrypt_1();
    rsa.setPrivateKey(privateKey);
    var key = rsa.getKey();
    text = b64tohex(text);
    var maxLength = ((key.n.bitLength() + 7) >> 3);
    try {
        if (text.length > maxLength) {
            var ct_2 = [];
            var lt = text.match(/.{1,256}/g);
            lt.forEach(function (entry) {
                var t1 = decryptByteArray(key, entry)
                ct_2 = ct_2.concat(t1);
            });

            let decoder = new TextDecoder("utf-8");
            let byteArray = new Uint8Array(ct_2)
            return decoder.decode(byteArray);
        }
        var y = decryptByteArray(key, entry)
        let decoder = new TextDecoder("utf-8");
        let byteArray = new Uint8Array(y)
        return decoder.decode(byteArray);
    }
    catch (ex) {
        return false;
    }
}

function chunk(array, size = 1) {
    const result = []

    const arrayLength = Math.ceil(array.length / size)

    let index = 0
    for (let i = 0; i < arrayLength; i++) {
        const temp = []
        if (i === arrayLength - 1) {
            for (let j = index; j < array.length; j++) {
                temp.push(array[j])
            }
            result.push(temp)
        } else {
            const length = index + size
            for (let j = index; j < length; j++) {
                temp.push(array[j])
            }
            result.push(temp)
            index = length
        }
    }

    return result
}
